module.exports = __webpack_public_path__ + "static/img/产品解决方案_图3@2x.93c08ed2.png";